module.exports = __webpack_public_path__ + "img/idle.94a4596f.png";